import { render, staticRenderFns } from "./ProductSectionStock.vue?vue&type=template&id=15da2147&scoped=true"
import script from "./ProductSectionStock.vue?vue&type=script&lang=js"
export * from "./ProductSectionStock.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionStock.vue?vue&type=style&index=0&id=15da2147&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da2147",
  null
  
)

export default component.exports